import script from "./PageSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSection.vue?vue&type=script&setup=true&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=066ede39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066ede39"]])

export default __exports__